exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".j3V1IT4DDVNieg{height:auto}.j3V1IT4DDVNieg span[name=star]{color:#f2d600}.j3V1IT4DDVNieg:active span[name=star],.j3V1IT4DDVNieg:focus span[name=star],.j3V1IT4DDVNieg:hover span[name=star]{color:#172b4d}", ""]);

// exports
exports.locals = {
	"yellowStar": "j3V1IT4DDVNieg"
};